import { TextInput, type TextInputProps } from "@mantine/core";
import {
  mergeFormInputClassNames,
  useFormInputStyles,
} from "./hooks/useFormInputStyles";

type FormTextInputProps = TextInputProps & {
  forceErrorState?: boolean;
};

export function FormTextInput({
  forceErrorState = false,
  disabled = false,
  styles,
  classNames,
  error,
  ...rest
}: FormTextInputProps) {
  const { forwardedError, resolvedStyles } = useFormInputStyles({
    error,
    forceErrorState,
    disabled,
    overrideStyles: styles as Parameters<
      typeof useFormInputStyles
    >[0]["overrideStyles"],
  });

  return (
    <TextInput
      {...rest}
      disabled={disabled}
      error={forwardedError}
      styles={resolvedStyles as TextInputProps["styles"]}
      classNames={mergeFormInputClassNames(classNames)}
    />
  );
}
